export const isPositiveInteger = (string: string) => /^\d+$/.test(string)
